export type Inscription = {
  id: number;
  name: string;
  subscription: Suscription;
  isSuspended: number;
  inscriptionPrice: number;
  initPrice: number;
  price: number;
  status: string;
  initDate: string;
  dues: number;
  remainingDues: number | null;
  user: User[];
  paymentAprobed?: PaymentData;
  paymentPending?: PaymentData;
};

export const inscriptionDictionary = {
  Aprobado: 'Aprobado',
  Pending: 'Pendiente',
  Decline: 'Rechazado',
  Pago: 'Pago',
};

export type PaymentData = {
  id: number;
  dues: number;
  inscriptionId: number;
  created_at: string;
  isPayment: number;
  orderId: number;
  type: string;
  amount: number;
  reference: string;
  issuingBank: string;
  receivingBank: string;
};

export type Suscription = {
  id: number;
  description: string;
  name: string;
  media: SuscriptionMedia[];
  duesQuantity: number;
  endDate: string | null;
  includesDues: number;
};

export type SuscriptionMedia = {
  file: string;
  id: number;
};

export type Module = {
  id: number;
  description: string;
  name: string;
  file: string;
  lessons: Lesson[];
  tests: TestItem[];
  plan: Inscription;
  moduleEnd: number;
};

export type TestItem = Lesson & {
  id: number;
  name: string;
  file?: string;
  question: Question[];
  learningModuleId: number;
  now: string;
  progress: number;
  progressTest?: ProgressTest;
  dateEnd: string;
  timeHours: number;
  timeMinutes: number;
  module: Module;
  title: string;
  description: string;
  repeat: boolean;
};

export type ProgressTest = {
  hitPercentage: number;
  qualification: number;
  qualificationMax: number;
  pendingForApprove: number;
};

export type Question = {
  id: number;
  name: string;
  type: 'trueOrFalse' | 'essayQuestions' | 'selectionMultiple' | 'selection';
  answer: Answer[];
  response: Response;
};

export type Response = {
  id?: number;
  answer: string;
  answerResponse: string;
  correct: string;
  correctId: string;
  multipleAnswer?: Response[];
};

export type Answer = {
  name: string;
  id: number;
};

export type Lesson = {
  name: string;
  progress: number;
  file: string;
  id: number;
  longDescription: string;
  module: Module;
  canView?: number;
  condicionalDate: string;
  reazon: string;
  repeat: boolean;
};

export type TestImage = {
  name: string;
  clientName: string;
  selected: boolean;
  file: {
    id: number;
    url: string;
    file: string;
  };
  title: string;
  subtitle: string;
  description: string;
  fullscreen: boolean;
};

export type Plan = {
  dues: number;
  motive: string;
  created_at: string;
  inscription: Inscription;
  id: number;
  name: string;
  amount: number;
  type: string;
  issuingBank: string;
  receivingBank: string;
  reference: string;
  isPayment: number;
};

export type PlanDetail = {
  duesQuantity: number;
  end?: string;
  init?: string;
  renovation?: string;
  inscriptionPrice?: number;
  name: string;
  price: number;
  total: number;
};

export type TestDetail = ProgressTest & {
  questions: Question[];
  test: TestItem;
  user: User;
};

export type User = {
  id: number;
  name: string;
};
